import React, { useState, useEffect, useMemo } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import SupplierRequestForm from './SupplierRequestForm'; // Componente para el formulario de solicitudes de proveedores
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import Input from '../../Components/Form/Input';
import TextArea from '../../Components/Form/TextArea';

const SupplierRequest = ({ nameSingle = 'Solicitud de Proveedor', namePlural = 'Solicitudes de Proveedores', separator = '-' }) => {
    const [isProcessing, setIsProcessing] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([]);
    const [loadSubmit, setLoadSubmit] = useState(false);
    const [dataUpdated, setDataUpdated] = useState({});
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false);
    const [dataDeleted, setDataDeleted] = useState({});

    const [alertType, setAlertType] = useState('')

    useEffect(() => {
        if (reload) {
            setIsProcessing(true);
            Controllers.supplier_request.get_supplier_request().then(res => {
                setRows(res.data);
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProcessing(false);
                    setReload(false);
                });
        }
    }, [reload]);

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true);
        Controllers.supplier_request.supplier_request_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast });
            if (res.response === 'success') {
                setModalShow(false);
                setDataUpdated({});
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false);
                setReload(true);
            });
    };

    const handleGet = e => {
        let $this = e.currentTarget;

        if (!$this.dataset?.idRequest) {
            setModalTitle(`Registrar ${nameSingle}`);
            setDataUpdated({});
            setModalShow(true);
            return;
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>';
        let { idRequest } = $this.dataset;
        console.log($this.dataset)

        Controllers.supplier_request.get_supplier_request_id({ p_id_supplier_request: idRequest }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idRequest}`);
            setDataUpdated({ data: res.data });
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast });
            setReload(true);
        })
            .finally(() => $this.innerHTML = buttonHTML);
    };

    const handleDelete = () => {
        setLoadSubmitDelete(true);

        Controllers.supplier_request.supplier_request_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast });
            if (res.response === 'success') {
                setShowConfirmDelete(false);
                setDataDeleted({});
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true);
                setLoadSubmitDelete(false);
            });
    };

    const handleHideModalForm = () => {
        setModalShow(false);
        setLoadSubmit(false);
    };

    const handleShowModalDelete = e => {
        let { idRequest } = e.currentTarget.dataset;
        setDataDeleted({
            p_id: idRequest
        });
        setAlertType('delete');
        setShowConfirmDelete(true);
    };

    const handleModalApprove = e => {
        let { idRequest } = e.currentTarget.dataset;
        setDataDeleted({
            p_id: idRequest
        });
        setAlertType('approve');
        setShowConfirmDelete(true);
    };

    const handleApprove = () => {
        setLoadSubmitDelete(true);

        Controllers.supplier_request.approve_supplier_request(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast });
            if (res.response === 'success') {
                setShowConfirmDelete(false);
                setDataDeleted({});
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true);
                setLoadSubmitDelete(false);
            });
    };

    const handleModalReject = e => {
        let { idRequest } = e.currentTarget.dataset;
        setDataDeleted({
            p_id: idRequest
        });
        setAlertType('reject');
        setShowConfirmDelete(true);
    };

    const handleReject = () => {
        if (!dataDeleted.p_rejection_reason) {
            Helpers.toast.construct({ response: 'warning', message: 'El campo de motivo de rechazo es obligatorio.', toast });
            return;
        }

        setLoadSubmitDelete(true);

        Controllers.supplier_request.reject_supplier_request(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast });
            if (res.response === 'success') {
                setShowConfirmDelete(false);
                setDataDeleted({});
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true);
                setLoadSubmitDelete(false);
            });
    };

    const handleHideModalDelete = () => setShowConfirmDelete(false);

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id', text: 'ID', align: 'center' },
                { name: 'supplier_name', text: 'Nombre del Proveedor' },
                { name: 'amount', text: 'Monto', align: 'center' },
                { name: 'request_date', text: 'Fecha de Solicitud', align: 'center' },
                {
                    name: 'status', text: 'Estado', align: 'center', render: r => <div className={'badge badge-' + (r.status === 'APPROVED' ? 'success' : r.status === 'REJECTED' ? 'danger' : 'warning')}>
                        {r.status === 'APPROVED' ? 'Aprobado' : r.status === 'REJECTED' ? 'Rechazado' : 'Pendiente'}
                    </div>
                },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            <Button variant="info" size="xs" data-id-request={u.id} onClick={handleGet}>
                                <i className={u.status === 'PENDING' ? 'fa fa-edit' : 'fa fa-eye'}></i>
                            </Button>
                            {u.status === 'PENDING' ? <Button variant="danger" className="ml-1" size="xs" data-id-request={u.id} data-name-request={u.name_request} onClick={handleShowModalDelete}>
                                <i className="fa fa-trash"></i>
                            </Button> : ''}
                            {u.status === 'PENDING' ? <Button variant="success" className="ml-1" size="xs" data-id-request={u.id} data-name-request={u.name_request} onClick={handleModalApprove}>
                                <i className="fa fa-check"></i>
                            </Button> : ''}
                            {u.status === 'PENDING' ? <Button variant="danger" className="ml-1" size="xs" data-id-request={u.id} data-name-request={u.name_request} onClick={handleModalReject}>
                                <i className="fa fa-ban"></i>
                            </Button> : ''}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing]);

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                <Button size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> Registrar {nameSingle}
                </Button>
            </Card.Header>
            <Card.Body>
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SupplierRequestForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        {alertType === 'delete' && <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />}
        {alertType === 'approve' && <SweetAlert
            icon="question"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea aprobar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id}</>}
            confirmButtonText="¡Sí, aprobar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleApprove}
        />}
        {alertType === 'reject' && <SweetAlert
            icon="question"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea rechazar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id}</>}
            confirmButtonText="¡Sí, rechazar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleReject}
            content={() => {
                return <>
                    <TextArea
                        text="Motivo de Rechazo"
                        placeholder="Motivo de Rechazo"
                        classNameParent="col-12 mb-2"
                        icon="far fa-comment"
                        required
                        invalid="El campo es obligatorio."
                        onChange={e => setDataDeleted({ ...dataDeleted, p_rejection_reason: e.currentTarget.value })}
                        maxLength={255}
                        rows={5}
                    />
                </>
            }}
        />}
    </>
}

export default SupplierRequest;
